import React from 'react';
import { Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Project = ({ project }) => {
    const { img, name, id } = project;
    return (
        <Col className="project">
            <Card.Img className="image" height="250px" variant="top" src={img} />
            <div className="middle">
                <div className="text">
                    <Card.Title>{name}</Card.Title>

                    <Link to={`/projects/${id}`}>
                        <button className="btn btn-outline-light rounded-pill mt-2">Read More</button></Link>
                </div>
            </div>
        </Col>
    );
};

export default Project;